export default __webpack_public_path__ + "static/media/cover-ikiga2.5e865097.png";